(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stu-playful-icon"] && !Shopify.designMode) return;
  try {
    (() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const icons = new WeakSet();
  const buttons = new WeakSet();
  let paused = false;
  try { paused = sessionStorage.getItem('stu-playful-motion-paused') === 'true'; } catch (_) {}
  const sync = () => {
    document.documentElement.classList.toggle('stu-doodles-paused', paused || motion.matches || document.hidden);
    document.querySelectorAll('[data-stu-motion-toggle]').forEach(button => {
      button.hidden = motion.matches;
      button.setAttribute('aria-pressed', String(paused));
      button.querySelector('[data-stu-motion-label]').textContent = paused ? button.dataset.resumeLabel : button.dataset.pauseLabel;
    });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('is-inview', entry.isIntersecting));
  }, { threshold: 0.15 }) : null;
  const watch = (root = document) => {
    root.querySelectorAll('[data-stu-doodle]').forEach(icon => {
      if (icons.has(icon)) return;
      icons.add(icon);
      if (observer) observer.observe(icon);
    });
    root.querySelectorAll('[data-stu-motion-toggle]').forEach(button => {
      if (buttons.has(button)) return;
      buttons.add(button);
      button.addEventListener('click', () => {
        paused = !paused;
        try { sessionStorage.setItem('stu-playful-motion-paused', String(paused)); } catch (_) {}
        sync();
      });
    });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => watch(), { once: true });
  else watch();
  document.addEventListener('shopify:section:load', event => watch(event.target));
  document.addEventListener('visibilitychange', sync);
  motion.addEventListener('change', sync);
})();
  } catch(e) { console.error(e); }
})();

})();
